module.exports = {"name":"@atlaskit/button","version":"14.0.0","sideEffects":false}